var _rect, _defs, _rect2, _ellipse, _text, _text2, _text3, _text4, _text5, _text6, _ellipse2, _text7, _text8, _text9, _text0, _text1, _text10, _ellipse3, _text11, _text12, _text13, _text14, _text15, _text16, _ellipse4, _text17, _text18, _text19, _text20, _text21, _text22, _rect3, _text23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopicModelingCardV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 450,
    fill: "#021727"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#0d2d4a",
    strokeWidth: 0.5,
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glow1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a4a7a",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d2d4a",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glow2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5c1a2a",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3a1218",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glow3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a5c3a",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d3a22",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glow4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5c4a1a",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3a2e0d",
    stopOpacity: 0.3
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 450,
    fill: "url(#grid)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 125,
    rx: 150,
    ry: 95,
    fill: "url(#glow1)",
    stroke: "#2a6090",
    strokeWidth: 1,
    opacity: 0.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 85,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#c09c4c",
    fontWeight: 700,
    letterSpacing: 3
  }, "TOPIC 1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 38,
    fontWeight: 700,
    fill: "#ffffff"
  }, "sinistre")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 155,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 18,
    fill: "#7eb8e0"
  }, "d\xE9claration")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 150,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 16,
    fill: "#a0c8e8"
  }, "contrat")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 185,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 15,
    fill: "#5a9ccc"
  }, "garantie")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#4a8aaa"
  }, "expertise")), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505,
    cy: 125,
    rx: 150,
    ry: 95,
    fill: "url(#glow2)",
    stroke: "#8b3040",
    strokeWidth: 1,
    opacity: 0.8
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 85,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#c09c4c",
    fontWeight: 700,
    letterSpacing: 3
  }, "TOPIC 2")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 120,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 38,
    fontWeight: 700,
    fill: "#ffffff"
  }, "r\xE9siliation")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 155,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 18,
    fill: "#e08888"
  }, "cotisation")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 150,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 16,
    fill: "#f0a0a0"
  }, "pr\xE9avis")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 185,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 15,
    fill: "#c06060"
  }, "tarif")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#a04444"
  }, "d\xE9lai")), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 340,
    rx: 150,
    ry: 95,
    fill: "url(#glow3)",
    stroke: "#2a8050",
    strokeWidth: 1,
    opacity: 0.8
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#c09c4c",
    fontWeight: 700,
    letterSpacing: 3
  }, "TOPIC 3")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 338,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#ffffff"
  }, "pr\xE9l\xE8vement")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 372,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 18,
    fill: "#80d0a0"
  }, "paiement")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 368,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 16,
    fill: "#a0e8c0"
  }, "IBAN")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 400,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 15,
    fill: "#60b080"
  }, "mensualit\xE9")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 395,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#40a060"
  }, "compte")), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505,
    cy: 340,
    rx: 150,
    ry: 95,
    fill: "url(#glow4)",
    stroke: "#8b7030",
    strokeWidth: 1,
    opacity: 0.8
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#c09c4c",
    fontWeight: 700,
    letterSpacing: 3
  }, "TOPIC 4")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 338,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#ffffff"
  }, "attestation")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 372,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 18,
    fill: "#e0c870"
  }, "document")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 368,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 16,
    fill: "#f0d880"
  }, "envoi")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 400,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 15,
    fill: "#c0a050"
  }, "certificat")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 395,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 14,
    fill: "#a08030"
  }, "courrier")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 210,
    width: 120,
    height: 32,
    rx: 16,
    fill: "#c09c4c",
    opacity: 0.15
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 232,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 13,
    fill: "#c09c4c",
    fontWeight: 600,
    letterSpacing: 1
  }, "HDBSCAN + BERT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicModelingCardV2);
export default __webpack_public_path__ + "static/media/topic_modeling_card_v2.afe0ba61c0f35a4c75b6942e8f0d02db.svg";
export { ForwardRef as ReactComponent };